import routeSnapshot from "./route-snapshot.json";

type Route = (typeof routeSnapshot.routes)[number];

const SNAPSHOT_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export function koreaToday(now = new Date()): string {
  return new Date(now.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function isCurrentRoute(route: Pick<Route, "effectiveTo">, checkedAt: string, now = new Date()): boolean {
  const age = now.getTime() - Date.parse(checkedAt);
  return Number.isFinite(age) && age >= 0 && age <= SNAPSHOT_MAX_AGE_MS
    && /^\d{4}[.-]\d{2}[.-]\d{2}$/.test(route.effectiveTo)
    && route.effectiveTo.replaceAll(".", "-") >= koreaToday(now);
}

export const currentStaticRoutes = (now = new Date()) =>
  routeSnapshot.routes.filter((route) => isCurrentRoute(route, routeSnapshot.checkedAt, now));
